// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/" + chunkId + "." + {"2008":"77a6a17d","3822":"b6f0c470","6135":"77a6a17d"}[chunkId] + ".css";
};